import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';
import font_awesome from '../gb-helper/font_awesome';


import color_palette_list from '../gb-helper/color_palette'
import image_box from '../icons/image_box'

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls, BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar, RichText, MediaUploadCheck, MediaUpload } = wp.editor;
const { PanelBody, PanelRow, SelectControl, Dashicon, Card, CardBody, Button,
    RangeControl, ColorIndicator, ColorPalette, ToggleControl, TextareaControl, TextControl, CheckboxControl } = wp.components;


registerBlockType('blocksbakery/image-box', {
    title: __('Image Box', 'blocks-bakery'),
    description: __(
        'This block helps you add an Image With Heading and Sub Heading',
        'blocks-bakery'
    ),
    category: 'blocks-bakery',
    icon: image_box.image_box,
    keywords: [
        __('image', 'blocks-bakery'),
        __('image box', 'blocks-bakery'),
        __('image', 'blocks-bakery')
    ],

    supports: {
        html: false
    },
    "attributes": {

        "image_selector": {
            "type": "string",
            "default": "fas fa-truck"
        },
        "ibheading": {
            "type": "string",
            "default": "Write a Heading"
        },
        "ibheadingtag": {
            "type": "string",
            "default": "h2",

        },
        "ibpara": {
            "type": "string",
            "default": "Paragraph"
        },
        "image_size": {
            "type": "number",
            "default": 20,
        },
        "headingml": {
            "type": "number",
            "default": 0
        },
        "headingmr": {
            "type": "number",
            "default": 10
        },
        "headingmt": {
            "type": "number",
            "default": 0
        },
        "headingmb": {
            "type": "number",
            "default": 0
        },
        "imageposition": {
            "type": "string",
            "default": 'default'
        },
        "imagepositionVertical": {
            "type": "string",
            "default": 'top'
        },
        "title_family": {
            "type": 'string',
            "default": 'Arial'
        },
        "title_weight": {
            "type": "string",
            "default": "regular"

        },
        "font_sizeib": {
            "type": 'number',
            "default": ''
        },
        "description_family": {
            "type": "string",
            "default": "Arial"
        },
        "description_weight": {

            "type": 'string',
            "default": "regular"

        },
        "description_sizeib": {
            "type": "number",
            "default": 16
        },
        "text_colr": {
            "type": "string",
            "default": "black"

        },
        "para_clr": {
            "type": "string",
            "default": "black"
        },

        "bg_wrap": {
            "type": 'string',
            "default": '',

        },
        "pl_wrap": {
            "type": "number",
            "default": 0,

        },
        "pr_wrap": {
            "type": "number",
            "default": 0,

        },
        "pt_wrap": {
            "type": "number",
            "default": 0,

        },
        "pb_wrap": {
            "type": "number",
            "default": 0,

        },
        "image_border": {
            "type": "number",
            "default": 1
        },
        "ic_bg_clr": {
            "type": "string",
            "default": "",
        },
        "border_style": {
            "type": "string",
            "default": "none"
        },
        "display_default": {
            "type": "string",
            "default": "block"

        },
        "display_left": {
            "type": "string",
            "default": "none"

        },
        "display_right": {

            "type": "string",
            "default": "none"

        },
        "alg": {
            "type": "string",
            "default": "none"
        },
        "wrap_border_radius": {
            "type": "number",
            "default": 0,
        },
        "border_radius_img": {
            "type": "number",
            "default": 0,
        },
        "bg_border": {
            "type": "string",
            "default": "black"
        },


        // FOR iMAGGE 

        "img_ID": {
            "type": 'number',
            "default": 0
        },
        "img_URL": {
            "type": 'string',

        },
        "img_alt": {
            "type": 'string',
            // "source": 'attribute',
            // "attribute": 'alt',
            // "selector": 'img'
        },
        "title_height": {
            "type": 'number',
            "default": 1.5
        },
        "letter_spacing_title": {
            "type": 'number',
            "default": 0
        },
        "text_transform": {
            "type": "string",
            "default": 'none',
        },
        "text_decoration": {
            "type": "string",
            "default": 'none',
        },
        "title_shadow_blur": {
            "type": 'number',
            "default": 10,
        },
        "text_shadow_horizental": {
            "type": 'number',
            "default": 0,
        },
        "text_shadow_vertical": {
            "type": 'number',
            "default": 0,
        },
        "text_shadow_clor": {
            "type": "string",
            "default": "",
        },

        //for description...

        "description_height": {
            "type": 'number',
            "default": 1.5
        },
        "letter_spacing_description": {
            "type": 'number',
            "default": 0
        },
        "description_transform": {
            "type": "string",
            "default": 'none',
        },
        "description_decoration": {
            "type": "string",
            "default": 'none',
        },
        "description_shadow_blur": {
            "type": 'number',

        },
        "description_shadow_horizental": {
            "type": 'number',
            "default": 0,
        },
        "description_shadow_vertical": {
            "type": 'number',
            "default": 0,
        },
        "description_shadow_clors": {
            "type": "string",
            "default": "",
        },

        //css blur...

        "css_blur": {
            "type": 'number',
            "default": 0,
        },
        "css_brightness": {
            "type": 'number',
            "default": 100,
        },
        "css_contrast": {
            "type": 'number',
            "default": 100,
        },
        "css_saturation": {
            "type": 'number',
            "default": 100,
        },
        "css_hue": {
            "type": 'number',
            "default": 0,
        },
        "text_shadow_clors": {
            "type": 'string',

        },
        "txtalgn": {
            "type": "string",
            "default": "center"
        },
        "pxfortile": {
            "type": "string",
            "default": 'px'
        },
        "description_empx": {
            "type": "string",
            "default": 'px'
        },
        "lineheightpxemfortitle": {
            "type": "string",
            "default": 'em'
        },
        "wrapper_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "image_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "heading_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "paragrpaph_style": {
            "source": "attribute",
            "attribute": "style"
        },
        "vertical_align": {
            "type": "string",
            "default": "none"
        },

        //New Attributes


        "image_size_dyna": {
            "type": "string",
        },
        "text_placeholder": {
            "type": "string",
            "default": "Enter the title"
        },
        "description_placeholder": {
            "type": "string",
            "default": "Enter the Description"
        },
        "icon_link": {
            "type": "string",
            "default": "#"
        },
        "open_tab_option": {
            "type": "boolean",
            "default": "false"
        },
        "open_tab": {
            "type": "string",
            "default": "null"
        },
        "rel_nofollow": {
            "type": "string",
            "default": "null"
        },
        "nofollow": {
            "type": "boolean",
            "default": "false"
        },
        "description_font_style": {
            "type": "string",
            "default": "initial",
        },
        "title_font_style": {
            "type": "string",
            "default": "initial",
        },
        "opacity_value": {
            "type": "string",
            "default": "1"
        },
        "css_hover_brightness": {
            "type": "number",
            "default": 100
        },
        "css_hover_contrast": {
            "type": "number",
            "default": 100
        },
        "css_hover_saturation": {
            "type": "number",
            "default": 100
        },
        "css_hover_hue": {
            "type": "number",
            "default": 0,
        },
        "css_hover_blur": {
            "type": "number",
            "default": 0,
        },
        "img_trans_duration": {
            "type": "number"
        },
        "image_wrapper_size": {
            "type": "number",
            "default":""
        
        },
        "font_controller": {
            "type": "number",
            "default": 200
        },
        "line_height_controller": {
            type: 'number',
            default: 10
        },
        "desc_controller":{
            type:'number',
            default: 200
        },
        desc_lh_controller:{
            type:'number',
            default:10
        }


    },


    edit: (props) => {

        const { attributes, setAttributes } = props;


        const select_img = (img) => {
            props.setAttributes({
                img_ID: img.id,
                img_URL: img.url,
                img_alt: img.alt
            })
        };
        const remove_img = () => {
            props.setAttributes({
                img_ID: null,
                img_URL: null,
                img_alt: null
            })
        };

        console.log(props.attributes.img_URL, "====>")

        const title_toggle = (new_val) => {
            props.setAttributes({text_shadow_clors:'black'})
            var x = document.getElementById("prifex-toggle");
            if (x.style.display === "block") {
                x.style.display = "none"
            }
            else if (x.style.display === "none") {
                x.style.display = "block";
            }

        }


        const description_toggle = (new_val) => {
            props.setAttributes({ text_shadow_clors: "black" })
            var x = document.getElementById("description-toggle");
            if (x.style.display === "block") {
                x.style.display = "none"
            }
            else if (x.style.display === "none") {
                x.style.display = "block";
            }

        }
        const description_remove = () => {
            props.setAttributes({ description_shadow_blur: 0 })
            props.setAttributes({ description_shadow_horizental: 0 })
            props.setAttributes({ description_shadow_vertical: 0 })
            props.setAttributes({ description_shadow_clors: '' })
        }

        const postion = (new_val) => {
            var x = document.querySelector(".bb-ib-wrapper");
            if (new_val === 'default') {
                console.log("default")
                x.style.display = "block"
            }
            else if (new_val === 'left') {
                console.log("left")
                var x = document.querySelector(".bb-ib-wrapper");
                x.style.display = "flex"

                x.style.alignItems = "center"
                x.style.flexDirection = "row"
            }
            else if (new_val === 'right') {
                console.log("row-reverse")
                var x = document.querySelector(".bb-ib-wrapper");
                x.style.display = "flex"

                x.style.alignItems = "center"
                x.style.flexDirection = "row-reverse"
            }
        }

        const cssfilter_toggle = () => {
            var x = document.getElementById("cssfilter_toggle")
            console.log("open")

            if (x.style.display === "block") {
                x.style.display = "none"
            }
            else if (x.style.display === "none") {
                x.style.display = "block"
            }
        }
        const cssfilter_remove = () => {
            props.setAttributes({ css_blur: 0 })
            props.setAttributes({ css_brightness: 100 })
            props.setAttributes({ css_contrast: 100 })
            props.setAttributes({ css_hue: 0 })
            props.setAttributes({ css_saturation: 100 })

        }

        const px_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "underline";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ pxfortile: 'px', font_controller: 200 })
            console.log("px")
        }
        const em_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "underline";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ pxfortile: 'em', font_controller: 10 })
            console.log("em")
        }
        const rem_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "underline";
            vw_case.style.textDecoration = "none";

            props.setAttributes({ pxfortile: 'rem', font_controller: 10 })
        }
        const vw_case = () => {
            var px_case = document.getElementById("px_case");
            var em_case = document.getElementById("em_case");
            var rem_case = document.getElementById("rem_case");
            var vw_case = document.getElementById("vw_case");
            px_case.style.textDecoration = "none";
            em_case.style.textDecoration = "none";
            rem_case.style.textDecoration = "none";
            vw_case.style.textDecoration = "underline";

            props.setAttributes({ pxfortile: 'vw', font_controller: 10 })
        }


        //em and px for description
        const px_description = () => {
            var px_description = document.getElementById("px_description");
            var em_description = document.getElementById("em_description");
            var rem_description = document.getElementById("rem_description");
            var vw_description = document.getElementById("vw_description");
            px_description.style.textDecoration = "underline";
            em_description.style.textDecoration = "none";
            rem_description.style.textDecoration = "none";
            vw_description.style.textDecoration = "none";
            props.setAttributes({ description_empx: "px", desc_controller:200 })
        }
        const em_description = () => {
            var px_description = document.getElementById("px_description");
            var em_description = document.getElementById("em_description");
            var rem_description = document.getElementById("rem_description");
            var vw_description = document.getElementById("vw_description");
            px_description.style.textDecoration = "none";
            em_description.style.textDecoration = "underline";
            rem_description.style.textDecoration = "none";
            vw_description.style.textDecoration = "none";
            props.setAttributes({ description_empx: "em",desc_controller:10 })
        }
        const rem_description = () => {
            var px_description = document.getElementById("px_description");
            var em_description = document.getElementById("em_description");
            var rem_description = document.getElementById("rem_description");
            var vw_description = document.getElementById("vw_description");
            px_description.style.textDecoration = "none";
            em_description.style.textDecoration = "none";
            rem_description.style.textDecoration = "underline";
            vw_description.style.textDecoration = "none";
            props.setAttributes({ description_empx: "rem", desc_controller:10})
        }
        const vw_description = () => {
            var px_description = document.getElementById("px_description");
            var em_description = document.getElementById("em_description");
            var rem_description = document.getElementById("rem_description");
            var vw_description = document.getElementById("vw_description");
            px_description.style.textDecoration = "none";
            em_description.style.textDecoration = "none";
            rem_description.style.textDecoration = "none";
            vw_description.style.textDecoration = "underline";
            props.setAttributes({ description_empx: "vw",desc_controller:10 })
        }

        //end for the description



        // Line Height px em  title
        const title_px = () => {
            var x = document.getElementById("title_px");
            var y = document.getElementById("title_em");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({desc_lh_controller:200})

        }
        const title_em = () => {
            var x = document.getElementById("title_px");
            var y = document.getElementById("title_em");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({desc_lh_controller:10})
        }


        //Line Height px em for tilte...........
        const title_px_lineh = () => {
            var x = document.getElementById("title_px_lineh");
            var x = document.getElementById("title_em_lineh");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({ lineheightpxemfortitle: 'px', line_height_controller: 200 })

        }

        const title_em_lineh = () => {
            var x = document.getElementById("title_px_lineh");
            var x = document.getElementById("title_em_lineh");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({ lineheightpxemfortitle: 'em', line_height_controller: 10 })

        }



        // Line Height px em  Description...........


        const description_px = () => {
            var x = document.getElementById("description_px");
            var y = document.getElementById("description_em");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";

        }
        const description_em = () => {
            var x = document.getElementById("description_px");
            var y = document.getElementById("description_em");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
        }



        //Rest the Box Shadow....

        const title_reset = () => {
            props.setAttributes({ text_shadow_horizental: 0 })
            props.setAttributes({ text_shadow_vertical: 0 })
            props.setAttributes({ text_shadow_clor: '' })
            props.setAttributes({ title_shadow_blur: 0 })
        }

        // const Imgae_size = (new_val) => {
        //     if (new_val === "th") {
        //         props.setAttributes({ image_size_dyna: "150" })
        //         console.log("Click Here")
        //     }
        //     if (new_val === "md") {
        //         props.setAttributes({ image_size_dyna: "300" })
        //     }
        //     else if (new_val === "ml") {
        //         props.setAttributes({ image_size_dyna: "768" })
        //     }
        //     else if (new_val === "ll") {
        //         props.setAttributes({ image_size_dyna: "1024" })
        //     }
        //     else if (new_val === "xl") {
        //         props.setAttributes({ image_size_dyna: "1536" })
        //     }
        //     else if (new_val === "xxl") {
        //         props.setAttributes({ image_size_dyna: "2048" })
        //     }
        //     else if (new_val === "hd") {
        //         props.setAttributes({ image_size_dyna: "100%" })
        //     }
        // }


        const open_link = () => {
            console.log("hello")
            var x = document.querySelector(".open_link");
            if (x.style.display === "none") {
                x.style.display = "block"
            }
            else {
                x.style.display = "none"
            }
        }




        //For Responsiveness
        const laptop = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Device');
        }
        const tablet = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Tablet');
        }
        const smartphone = () => {
            wp.data.dispatch('core/edit-post').__experimentalSetPreviewDeviceType('Mobile');
        }


        //Image Opacity

        // const hexConverter = (val) => {
        //     val = Math.round(val * 100) / 100;
        //     var alpha = Math.round(val * 255);
        //     var hex = (alpha + 0x10000).toString(16).substr(-2).toUpperCase();
        //     props.setAttributes({ opacity_value: hex })
        // }


        //FIleter on Hover
        const imgFilterHoverResetPanel = () => {
            setAttributes({ css_hover_blur: 0 })
            setAttributes({ css_hover_brightness: 100 })
            setAttributes({ css_hover_contrast: 100 })
            setAttributes({ css_hover_hue: 0 })
            setAttributes({ css_hover_saturation: 100 })
        }

        //Image hover Edit Panel

        const imgFilterHoverEditPanel = () => {
            var filter_edit_panel = document.getElementById("img_hover_filter_edit_panel");
            var filter_reset_display = document.getElementById("filter_hover_reset_display");
            filter_reset_display.style.display = "inline-block"
            if (filter_edit_panel.style.display === "block") {
                filter_edit_panel.style.display = "none"
            }
            else if (filter_edit_panel.style.display === "none") {
                filter_edit_panel.style.display = "block";
            }
        }



        //Image Hover and Normal Function..


        const imgHover = (e) => {
            const hover = e.target.style;
            hover.opacity = attributes.img_hover_opacity;
            hover.filter = `brightness(${attributes.css_hover_brightness}%) contrast(${attributes.css_hover_contrast}%) saturate(${attributes.css_hover_saturation}%) blur(${attributes.css_hover_blur}px) hue-rotate(${attributes.css_hover_hue}deg)`
            hover.transitionDuration = attributes.img_trans_duration;
            // hover.borderType = attributes.img_border_hover_style;
            // hover.borderWidth = attributes.border_top_hover_width + "px " + attributes.border_right_hover_width + "px " + attributes.border_bottom_hover_width + "px " + attributes.border_left_hover_width + "px ";
            // hover.borderRadius = attributes.border_hover_top_radius + attributes.img_border_hover_radius_unit + " " + attributes.border_hover_right_radius + attributes.img_border_hover_radius_unit + " " + attributes.border_hover_bottom_radius + attributes.img_border_hover_radius_unit + " " + attributes.border_hover_left_radius + attributes.img_border_hover_radius_unit + " ";
            hover.boxShadow = attributes.img_hover_shadow_horizental + 'px ' + attributes.img_hover_shadow_vertical + 'px ' + attributes.img_hover_shadow_blur + 'px ' + attributes.img_hover_shadow_color;


        }
        const imgNormal = (e) => {
            const normal = e.target.style;
            normal.opacity = attributes.img_opacity;
            normal.filter = `brightness(${props.attributes.css_brightness}%) contrast(${props.attributes.css_contrast}%) saturate(${props.attributes.css_saturation}%) blur(${props.attributes.css_blur}px) hue-rotate(${props.attributes.css_hue}deg)`;
            normal.boxShadow = attributes.img_shadow_horizontal + 'px ' + attributes.img_shadow_vertical + 'px ' + attributes.img_shadow_blur + 'px ' + attributes.img_shadow_color;

        }


        return (

            <div className="bb-ib-image">
                <InspectorControls>
                    <PanelBody title={__("Positions")} >

                        <SelectControl
                            label="Alignment"
                            options={[
                                { label: 'default', value: 'default' },
                                { label: 'Left', value: 'left' },
                                { label: 'Right', value: 'right' },

                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ imageposition: new_val })
                                if (new_val === "default") {
                                    props.setAttributes({ display_default: "block" })
                                    props.setAttributes({ display_left: "none" })
                                    props.setAttributes({ display_right: "none" })
                                    props.setAttributes({ vertical_align: "none" })
                                }

                                else if (new_val === "left") {
                                    props.setAttributes({ display_default: "none" })
                                    props.setAttributes({ display_left: "flex" })
                                    props.setAttributes({ display_right: "none" })
                                    props.setAttributes({ vertical_align: "block" })

                                }
                                else if (new_val === "right") {
                                    props.setAttributes({ display_default: "none" })
                                    props.setAttributes({ display_left: "none" })
                                    props.setAttributes({ display_right: "flex" })
                                    props.setAttributes({ vertical_align: "block" })
                                }
                            }}

                        />


                        <SelectControl
                            label="Content Alingment"
                            options={[
                                { label: 'Center', value: 'center' },
                                { label: 'Left', value: 'left' },
                                { label: 'Right', value: 'right' },
                                { label: 'Justify', value: 'justify' },

                            ]}
                            onChange={(new_val) => {
                                if (new_val === "center") {
                                    props.setAttributes({ txtalgn: "center" })
                                }
                                else if (new_val === "left") {
                                    props.setAttributes({ txtalgn: "left" })
                                }
                                else if (new_val === "right") {
                                    props.setAttributes({ txtalgn: "right" })
                                }
                                else if (new_val === "justify") {
                                    props.setAttributes({ txtalgn: "justify" })
                                }
                            }}

                        />




                        <div style={{ display: props.attributes.vertical_align }}>
                            <SelectControl
                                label="Icon Vertical Alignment"
                                options={[
                                    { label: 'Top', value: 'top' },
                                    { label: 'Middle', value: 'middle' },
                                    { label: 'bottom', value: 'bottom' },

                                ]}
                                onChange={(new_val) => {
                                    props.setAttributes({ imagepositionVertical: new_val })
                                    if (new_val === 'top') {
                                        props.setAttributes({ alg: "flex-start" })
                                    }
                                    else if (new_val === 'middle') {
                                        props.setAttributes({ alg: "center" })
                                    }
                                    else if (new_val === 'bottom') {
                                        props.setAttributes({ alg: "flex-end" })
                                    }

                                }}

                            />
                        </div>
                    </PanelBody>
                    <PanelBody title={__("Image")} >
                        <div className="image-box-uploader">
                            <span style={{ marginRight: '14px' }}> Select Imgae </span>
                            {props.attributes.img_ID ? (
                                <div className="image-ctr">
                                    <figure>
                                        <img src={props.attributes.img_URL}
                                            alt={props.attributes.img_alt}

                                        />

                                    </figure>
                                    {props.isSelected ? (
                                        <Button className="btn-remove" onClick={remove_img}>
                                            <Dashicon icon='no' size='20' />
                                        </Button>
                                    ) : null}
                                </div>
                            ) : (
                                <MediaUploadCheck>
                                    <MediaUpload
                                        allowedType={['image']}
                                        value={props.attributes.img_ID}
                                        onSelect={select_img}
                                        render={({ open }) => (
                                            <Button className={"button button-large"} onClick={open}>
                                                {__('Upload Image', 'block-quote')}
                                            </Button>
                                        )}></MediaUpload>
                                </MediaUploadCheck>
                            )}
                        </div>

                        <br />


                        <SelectControl
                            label={__("Image Size", "blocks_bakery")}
                            value={props.attributes.image_size_dyna}
                            options={[
                                { label: 'Thumbnail - 150 x 150', value: '150' },
                                { label: 'Medium - 300 x 300', value: '300' },
                                { label: 'Medium Large - 768 x 768', value: '768' },
                                { label: 'Large - 1024 x 1024', value: '1024' },
                                { label: '1536 x 1536 - 1536 x 1536', value: '1536' },
                                { label: '2048 x 2048 - 2048 x 2048', value: '2048' },
                                { label: 'Full', value: '100%' },
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ image_size_dyna: new_val })
                               
                            }} />


                        <br />
                        <TextControl
                            label="Title/Description"
                            placeholder={props.attributes.text_placeholder}
                            value={props.attributes.ibheading}
                            onChange={(value) => props.setAttributes({ ibheading: value })}
                        />

                        <TextareaControl
                            label="Title/Description"
                            placeholder={props.attributes.description_placeholder}
                            value={props.attributes.ibpara}
                            onChange={(value) => props.setAttributes({ ibpara: value })}
                        />
                        <hr />


                        <p>Image Opacity</p>
                        <RangeControl
                            min={0}
                            max={1}
                            value={props.attributes.opacity_value}
                            step={0.01}
                            onChange={(new_val) => {
                                props.setAttributes({ opacity_value: new_val })
                                hexConverter(new_val)
                            }}
                        />

                        <p>Link</p>

                        <div style={{ display: "flex" }}>
                            <div style={{ width: "85%" }}>
                                <TextControl

                                    value={props.attributes.icon_link}
                                    onChange={(new_val) => {
                                        props.setAttributes({ icon_link: new_val })
                                    }}
                                />

                            </div>
                            <div className="" style={{ width: "15%", border: "1px solid black", height: "31px", textAlign: "center", lineHeight: "29px", cursor: "pointer" }}>
                                <i class="eicon-cog" aria-hidden="true" onClick={open_link}></i>

                            </div>
                        </div>




                        <div className="open_link" style={{ display: "none" }}>
                            <CheckboxControl
                                label="open in new window"
                                checked={props.attributes.open_tab_option}
                                onChange={(value) => {
                                    if (value === false) {
                                        props.setAttributes({ open_tab: "_self", open_tab_option: false })
                                    } else {
                                        props.setAttributes({ open_tab: "_blank", open_tab_option: true })
                                    }
                                }
                                }
                            />
                            <CheckboxControl
                                label="Add nofollow"
                                checked={props.attributes.nofollow}
                                onChange={(value) => {
                                    if (value === false) {
                                        props.setAttributes({ rel_nofollow: null, nofollow: false })
                                    } else {
                                        props.setAttributes({ rel_nofollow: "nofollow", nofollow: true })
                                    }
                                }
                                }
                            />
                        </div>




                        {/* End of the image size */}


                        <RangeControl
                            label="Image Size (%)"
                            min={0}
                            max={100}
                            initialPosition={20}
                            value={props.attributes.image_wrapper_size}
                            onChange={(new_val) => {
                                props.setAttributes({ image_wrapper_size: new_val })
                            }}

                        />
                        <RangeControl
                            label="Border Raidus "
                            min={0}
                            max={200}
                            initialPosition={0}
                            value={props.attributes.border_radius_img}
                            onChange={(new_val) => {
                                props.setAttributes({ border_radius_img: new_val })
                            }}

                        />

                        <PanelRow>
                            <p>CSS Filter</p>
                            <div>
                                <Button onClick={cssfilter_remove} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button onClick={cssfilter_toggle} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="cssfilter_toggle" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>

                                <RangeControl
                                    label="Blur"
                                    min={0}
                                    max={10}
                                    initialPosition={0}
                                    value={props.attributes.css_blur}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_blur: new_val })
                                    }}

                                />

                                <RangeControl
                                    label="Brightness"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_brightness}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_brightness: new_val })
                                    }}

                                />

                                <RangeControl
                                    label="Contrast"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_contrast}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_contrast: new_val })
                                    }}

                                />

                                <RangeControl
                                    label="Saturation"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_saturation}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_saturation: new_val })
                                    }}

                                />

                                <RangeControl
                                    label="Hue"
                                    min={0}
                                    max={360}
                                    initialPosition={0}
                                    value={props.attributes.css_hue}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_hue: new_val })
                                    }}

                                />


                            </CardBody>
                        </Card>


                    </PanelBody>

                    <PanelBody title={__("Title")}>
                        <SelectControl
                            label="Title  Heading"
                            options={[
                                { label: 'h1', value: 'h1' },
                                { label: 'h2', value: 'h2' },
                                { label: 'h3', value: 'h3' },
                                { label: 'h4', value: 'h4' },
                                { label: 'h5', value: 'h5' },
                                { label: 'h6', value: 'h6' },
                                { label: 'div', value: 'div' },
                                { label: 'span', value: 'span' },
                                { label: 'p', value: 'p' },
                            ]}
                            value={props.attributes.ibheadingtag}
                            onChange={(new_val) => {
                                props.setAttributes({ ibheadingtag: new_val })
                            }}
                        />

                        < SelectControl
                            label="Font Family"
                            options={all_font_families}
                            onChange={(new_val) => {
                                props.setAttributes({ title_family: new_val })
                            }}
                            value={props.attributes.title_family}

                        />
                        <SelectControl
                            label="Font Weight"
                            options={[
                                { label: '100', value: 100 },
                                { label: '200', value: 200 },
                                { label: '300', value: 300 },
                                { label: '400', value: 400 },
                                { label: '500', value: 500 },
                                { label: '600', value: 600 },
                                { label: '700', value: 700 },
                                { label: '800', value: 800 },
                                { label: '900', value: 900 },
                                { label: 'Default', value: '' },
                                { label: 'Normal', value: 'normal' },
                                { label: 'Bold', value: 'bold' }
                            ]}
                            onChange={(new_val) => {
                                props.setAttributes({ title_weight: new_val })
                            }}
                            value={props.attributes.title_weight}
                        />



                        <SelectControl
                            label="Text Transform"
                            options={[
                                { label: 'default', value: 'none' },
                                { label: 'Uppercase', value: 'uppercase' },
                                { label: 'Lowercase', value: 'lowercase' },
                                { label: 'Capitlized', value: 'capitalize' },
                                { label: 'Normal', value: 'normal' },

                            ]}
                            value={props.attributes.text_transform}
                            onChange={(new_val) => {
                                props.setAttributes({ text_transform: new_val })
                            }}
                        />
                        <SelectControl
                            label="Style"
                            options={[
                                { label: 'Default', value: 'initial' },
                                { label: 'Normal', value: 'normal' },
                                { label: 'Italic', value: 'italic' },
                                { label: 'Capitlized', value: 'capitalize' },
                                { label: 'Oblique', value: 'oblique' },

                            ]}
                            value={props.attributes.title_font_style}
                            onChange={(new_val) => {
                                props.setAttributes({ title_font_style: new_val })
                            }}
                        />



                        <SelectControl
                            label="Decoration"
                            options={[
                                { label: 'Default', value: 'none' },
                                { label: 'Underline', value: 'underline' },
                                { label: 'line Through', value: 'line-through' },
                                { label: 'Line Trough and Underline', value: 'underline line-through' },
                                { label: 'overline', value: 'overline' },


                            ]}
                            value={props.attributes.text_decoration}
                            onChange={(new_val) => {
                                props.setAttributes({ text_decoration: new_val })
                            }}
                        />

                        <PanelRow>
                            <p>Typography</p>

                            <div>
                                <Button id="px_case" onClick={px_case} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="em_case" onClick={em_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                                <Button id="rem_case" onClick={rem_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>rem</Button>
                                <Button id="vw_case" onClick={vw_case} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vw</Button>
                            </div>
                        </PanelRow>
                        <RangeControl
                            label="Title Font Size"
                            min={0}
                            max={props.attributes.font_controller}
                            step={1}
                            initialPosition={26}
                            value={props.attributes.font_sizeib}
                            onChange={(new_val) => {
                                props.setAttributes({ font_sizeib: new_val })
                            }}
                        />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Responsive Line Height</p>
                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        </div>

                        <PanelRow>
                            <p>Typography</p>

                            <div>
                                <Button id="title_px_lineh" onClick={title_px_lineh} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="title_em_lineh" onClick={title_em_lineh} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                            </div>
                        </PanelRow>
                        <br />

                        <RangeControl
                            label="Title Line Height "
                            min={0}
                            max={props.attributes.line_height_controller}
                            step={0.1}
                            initialPosition={1.5}
                            value={props.attributes.title_height}
                            onChange={(new_val) => {
                                props.setAttributes({ title_height: new_val })
                            }}
                        />

                        <br />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Responsive Letter Spacing</p>
                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        </div>
                        <RangeControl
                            label="Letter Spacing (px)"
                            min={-5}
                            max={10}
                            step={1}
                            initialPosition={0}
                            value={props.attributes.letter_spacing_title}
                            onChange={(new_val) => {
                                props.setAttributes({ letter_spacing_title: new_val })
                            }}
                        />


                        <PanelRow>
                            <p>Text Shadow</p>
                            <div>
                                <Button onClick={title_reset} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button onClick={title_toggle} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="prifex-toggle" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>

                                <RangeControl
                                    label="Blur"
                                    min={0}
                                    max={100}
                                    step={1}
                                    initialPosition={10}
                                    value={props.attributes.title_shadow_blur}
                                    onChange={(new_val) => {
                                        props.setAttributes({ title_shadow_blur: new_val })
                                        console.log("Bur")
                                    }}
                                />
                                <RangeControl
                                    label="Horizontal"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.text_shadow_horizental}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_horizental: new_val })
                                        console.log("horitzental")
                                    }}
                                />

                                <RangeControl
                                    label="Vertical"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.text_shadow_vertical}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_vertical: new_val })
                                        console.log("vertical")
                                    }}
                                />

                                <p>Color<span> <ColorIndicator
                                    style={{ backgroundColor: props.attributes.text_shadow_clors }} /></span></p>
                                <ColorPalette
                                    colors={color_palette_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ text_shadow_clors: new_val })

                                    }}
                                    value={props.attributes.text_shadow_clors}
                                />
                                <Button style={{
                                    background: '#007cba', position: "relative", top: "-28px", left: "174px", border: '1px solid #007cba', fontSize: '12px', width: "24%", height: "30px", color: "#ffffff"
                                }}
                                    onClick={() => {
                                        var x = document.querySelector(".bb-ib-heading");
                                        x.style.backgroundColor = "transparent"
                                        props.setAttributes({ text_shadow_clors: 'transparent' })
                                    }}> Reset
                                </Button>
                            </CardBody>
                        </Card>

                    </PanelBody>


                    <PanelBody title={__("Description")}>
                        < SelectControl
                            label="Font Family"
                            options={all_font_families}
                            onChange={(new_val) => {
                                props.setAttributes({ description_family: new_val })
                            }}
                            value={props.attributes.description_family}

                        />
                        <SelectControl
                            label="Font Weight"
                            options={
                                [
                                    { label: '100', value: 100 },
                                    { label: '200', value: 200 },
                                    { label: '300', value: 300 },
                                    { label: '400', value: 400 },
                                    { label: '500', value: 500 },
                                    { label: '600', value: 600 },
                                    { label: '700', value: 700 },
                                    { label: '800', value: 800 },
                                    { label: '900', value: 900 },
                                    { label: 'Default', value: '' },
                                    { label: 'Normal', value: 'normal' },
                                    { label: 'Bold', value: 'bold' }
                                ]
                            }
                            onChange={(new_val) => {
                                props.setAttributes({ description_weight: new_val })
                            }}
                            value={props.attributes.description_weight}
                        />

                        <PanelRow>
                            <p>Typography</p>

                            <div>
                                <Button id="px_description" onClick={px_description} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="em_description" onClick={em_description} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                                <Button id="rem_description" onClick={rem_description} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>rem</Button>
                                <Button id="vw_description" onClick={vw_description} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>vw</Button>
                            </div>
                        </PanelRow>

                        <RangeControl
                            label="Description Font Size"
                            min={0}
                            max={props.attributes.desc_controller}
                            step={0.1}
                            initialPosition={26}
                            value={props.attributes.description_sizeib}
                            onChange={(new_val) => {
                                props.setAttributes({ description_sizeib: new_val })
                            }}
                        />


                        <SelectControl
                            label="Text Transform"
                            options={[
                                { label: 'default', value: 'none' },
                                { label: 'Uppercase', value: 'uppercase' },
                                { label: 'Lowercase', value: 'lowercase' },
                                { label: 'Capitlized', value: 'capitalize' },
                                { label: 'Normal', value: 'normal' },

                            ]}
                            value={props.attributes.description_transform}
                            onChange={(new_val) => {
                                props.setAttributes({ description_transform: new_val })
                            }}
                        />


                        <SelectControl
                            label="Style"
                            options={[
                                { label: 'Default', value: 'initial' },
                                { label: 'Normal', value: 'normal' },
                                { label: 'Italic', value: 'italic' },
                                { label: 'Capitlized', value: 'capitalize' },
                                { label: 'Oblique', value: 'oblique' },

                            ]}
                            value={props.attributes.description_font_style}
                            onChange={(new_val) => {
                                props.setAttributes({ description_font_style: new_val })
                            }}
                        />


                        <SelectControl
                            label="Decoration"
                            options={[
                                { label: 'Default', value: 'none' },
                                { label: 'Underline', value: 'underline' },
                                { label: 'line Through', value: 'line-through' },
                                { label: 'Line Trough and Underline', value: 'underline line-through' },
                                { label: 'overline', value: 'overline' },


                            ]}
                            value={props.attributes.description_decoration}
                            onChange={(new_val) => {
                                props.setAttributes({ description_decoration: new_val })
                            }}
                        />
                        <PanelRow>

                            <p>Description Line Height (em)</p>
                            <div>
                                <Button id="title_px" onClick={title_px} style={{ textDecoration: "underline", padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>px</Button>
                                <Button id="title_em" onClick={title_em} style={{ padding: 0, boxShadow: "none", textTransform: "uppercase", fontSize: 10, marginRight: 5 }}>em</Button>
                            </div>
                        </PanelRow>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Responsive Line Height</p>
                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        </div>
                        <RangeControl

                            min={0}
                            max={props.attributes.desc_lh_controller}
                            step={0.1}
                            initialPosition={1.5}
                            value={props.attributes.description_height}
                            onChange={(new_val) => {
                                props.setAttributes({ description_height: new_val })
                            }}
                        />

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p>Responsive Letter Spacing</p>
                            <div>
                                <Dashicon style={{ cursor: 'pointer' }} onClick={laptop} icon='laptop' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={tablet} icon='tablet' />
                                <Dashicon style={{ cursor: 'pointer' }} onClick={smartphone} icon='smartphone' />
                            </div>
                        </div>
                        <RangeControl
                            label="Letter Spacing (px)"
                            min={-5}
                            max={10}
                            step={1}
                            initialPosition={0}
                            value={props.attributes.letter_spacing_description}
                            onChange={(new_val) => {
                                props.setAttributes({ letter_spacing_description: new_val })
                            }}
                        />


                        <PanelRow>
                            <p>Text Shadow Sub Heading</p>
                            <div>
                                <Button onClick={description_remove} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button onClick={description_toggle} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="description-toggle" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>

                                <RangeControl
                                    label="Blur"
                                    min={0}
                                    max={100}
                                    step={1}
                                    initialPosition={10}
                                    value={props.attributes.description_shadow_blur}
                                    onChange={(new_val) => {
                                        props.setAttributes({ description_shadow_blur: new_val })
                                        console.log("Bur")
                                    }}
                                />
                                <RangeControl
                                    label="Horizontal"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.description_shadow_horizental}
                                    onChange={(new_val) => {
                                        props.setAttributes({ description_shadow_horizental: new_val })
                                        console.log("horitzental")
                                    }}
                                />

                                <RangeControl
                                    label="Vertical"
                                    min={-100}
                                    max={100}
                                    step={1}
                                    initialPosition={0}
                                    value={props.attributes.description_shadow_vertical}
                                    onChange={(new_val) => {
                                        props.setAttributes({ description_shadow_vertical: new_val })
                                        console.log("vertical")
                                    }}
                                />

                                <p>Color<span> <ColorIndicator
                                    style={{ backgroundColor: props.attributes.description_shadow_clors }} /></span></p>
                                <ColorPalette
                                    colors={color_palette_list}
                                    onChange={(new_val) => {
                                        props.setAttributes({ description_shadow_clors: new_val })

                                    }}
                                    value={props.attributes.description_shadow_clors}
                                />
                                <Button style={{
                                    background: '#007cba', position: "relative", top: "-28px", left: "174px", border: '1px solid #007cba', fontSize: '12px', width: "24%", height: "30px", color: "#ffffff"
                                }}
                                    onClick={() => {

                                        props.setAttributes({ description_shadow_clors: 'transparent' })
                                    }}> Reset
                                </Button>

                            </CardBody>
                        </Card>


                    </PanelBody>

                    <PanelBody title={__("Spacing")}>
                        <RangeControl
                            label="Image Margin Left"
                            min={0}
                            max={100}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.headingml}
                            onChange={(new_val) => {
                                props.setAttributes({ headingml: new_val })
                            }}

                        />

                        <RangeControl
                            label="Image Margin Right"
                            min={0}
                            max={100}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.headingmr}
                            onChange={(new_val) => {
                                props.setAttributes({ headingmr: new_val })
                            }}

                        />

                        <RangeControl
                            label="Image Margin Top"
                            min={0}
                            max={100}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.headingmt}
                            onChange={(new_val) => {
                                props.setAttributes({ headingmt: new_val })
                            }}

                        />

                        <RangeControl
                            label="Image Margin Bottom"
                            min={0}
                            max={100}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.headingmb}
                            onChange={(new_val) => {
                                props.setAttributes({ headingmb: new_val })
                            }}

                        />

                        <hr />

                        <RangeControl
                            label="Wrapper Padding Left"
                            min={0}
                            max={100}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.pl_wrap}
                            onChange={(new_val) => {
                                props.setAttributes({ pl_wrap: new_val })
                            }}

                        />


                        <RangeControl
                            label="Wrapper Padding Right"
                            min={0}
                            max={100}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.pr_wrap}
                            onChange={(new_val) => {
                                props.setAttributes({ pr_wrap: new_val })
                            }}

                        />

                        <RangeControl
                            label="Wrapper Padding Top"
                            min={0}
                            max={100}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.pt_wrap}
                            onChange={(new_val) => {
                                props.setAttributes({ pt_wrap: new_val })
                            }}

                        />

                        <RangeControl
                            label="Wrapper Padding Bottom"
                            min={0}
                            max={100}
                            step={0.1}
                            initialPosition={0}
                            value={props.attributes.pb_wrap}
                            onChange={(new_val) => {
                                props.setAttributes({ pb_wrap: new_val })
                            }}

                        />




                    </PanelBody>

                    <PanelBody title={__("Colors")}>




                        <p>Title Color <span> <ColorIndicator
                            style={{ backgroundColor: props.attributes.text_colr }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ text_colr: new_val })

                            }}
                            value={props.attributes.text_colr}
                        />


                        <p>Paragraph  Color <span> <ColorIndicator
                            style={{ backgroundColor: props.attributes.para_clr }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ para_clr: new_val })

                            }}
                            value={props.attributes.para_clr}
                        />

                        <p>Background Color <span> <ColorIndicator
                            style={{ backgroundColor: props.attributes.bg_wrap }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ bg_wrap: new_val })

                            }}
                            value={props.attributes.bg_wrap}
                        />


                        <p>Border Color Wrapper <span> <ColorIndicator
                            style={{ backgroundColor: props.attributes.bg_border }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ bg_border: new_val })

                            }}
                            value={props.attributes.bg_border}
                        />



                    </PanelBody>

                    <PanelBody title={__("Border")}>

                        <RangeControl
                            label="Wrapper Border"
                            min={0}
                            max={200}
                            steps={0.1}
                            initialPosition={0}
                            value={props.attributes.image_border}
                            onChange={(new_val) => {
                                props.setAttributes({ image_border: new_val })
                            }}

                        />



                        <SelectControl
                            label="Border Style"
                            options={[
                                { label: 'None', value: 'none' },
                                { label: 'Solid', value: 'solid' },
                                { label: 'Dotted', value: 'dotted' },
                                { label: 'Dashed', value: 'dashed' },
                                { label: 'Double', value: 'double' },
                                { label: 'Inset', value: 'inset' },

                            ]}
                            value={props.attributes.border_style}
                            onChange={(new_val) => {
                                props.setAttributes({ border_style: new_val })
                            }}
                        />

                        <RangeControl
                            label="Wrapper Border Radius"
                            min={0}
                            max={200}
                            initialPosition={0}
                            value={props.attributes.wrap_border_radius}
                            onChange={(new_val) => {
                                props.setAttributes({ wrap_border_radius: new_val })
                            }}
                        />
                    </PanelBody>


                    <PanelBody title={__("Hover")}>
                        <PanelRow>
                            <p>Image Hover Filters</p>
                            <div>
                                <Button onClick={imgFilterHoverResetPanel} id="filter_hover_reset_display" style={{ display: 'none', paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button onClick={imgFilterHoverEditPanel} style={{ textDecoration: "underline", paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="edit" style={{ fontSize: 15 }} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="img_hover_filter_edit_panel" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <RangeControl
                                    label="Blur"
                                    min={0}
                                    max={10}
                                    initialPosition={0}
                                    value={props.attributes.css_hover_blur}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_hover_blur: new_val })
                                    }}
                                />
                                <RangeControl
                                    label="Brightness"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_hover_brightness}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_hover_brightness: new_val })
                                    }}
                                />
                                <RangeControl
                                    label="Contrast"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_hover_contrast}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_hover_contrast: new_val })
                                    }}
                                />
                                <RangeControl
                                    label="Saturation"
                                    min={0}
                                    max={200}
                                    initialPosition={100}
                                    value={props.attributes.css_hover_saturation}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_hover_saturation: new_val })
                                    }}
                                />
                                <RangeControl
                                    label="Hue"
                                    min={0}
                                    max={360}
                                    initialPosition={0}
                                    value={props.attributes.css_hover_hue}
                                    onChange={(new_val) => {
                                        props.setAttributes({ css_hover_hue: new_val })
                                    }}
                                />
                            </CardBody>
                        </Card>
                        <hr />
                        <RangeControl
                            label="Transition Duration"
                            min={0}
                            max={3}
                            step={1}
                            initialPosition={0}
                            value={props.attributes.img_trans_duration}
                            onChange={(new_val) => {
                                props.setAttributes({ img_trans_duration: new_val })
                            }}
                        />
                    </PanelBody>
                </InspectorControls>


                <div className="bb-ib-wrapper"
                    style={{
                        textAlign: props.attributes.txtalgn,
                        backgroundColor: props.attributes.bg_wrap,
                        paddingTop: props.attributes.pt_wrap,
                        paddingRight: props.attributes.pr_wrap,
                        paddingBottom: props.attributes.pb_wrap,
                        paddingLeft: props.attributes.pl_wrap,
                        display: props.attributes.display_default,
                        borderRadius: props.attributes.wrap_border_radius,
                        borderWidth: props.attributes.image_border,
                        borderStyle: props.attributes.border_style,
                        borderColor: props.attributes.bg_border,


                    }}>

                    <div className="bb-ib-icon"
                        style={{ alignSelf: props.attributes.alg }}
                    >

                        <figure >
                            <a href={props.attributes.icon_link} target={props.attributes.open_tab} rel={props.attributes.rel_nofollow}>

                                <img
                                    style={{
                                        // width: props.attributes.image_size+"%",
                                        // height: props.attributes.image_size,
                                        borderRadius: props.attributes.border_radius_img,
                                        marginLeft: props.attributes.headingml,
                                        marginRight: props.attributes.headingmr,
                                        marginTop: props.attributes.headingmt,
                                        marginBottom: props.attributes.headingmb,
                                        width: props.attributes.image_wrapper_size + "%",
                                        filter: `brightness( ${props.attributes.css_brightness}% ) contrast( ${props.attributes.css_contrast}% ) saturate( ${props.attributes.css_saturation}% ) blur( ${props.attributes.css_blur}px ) hue-rotate( ${props.attributes.css_hue}deg )`,
                                        opacity: props.attributes.opacity_value,

                                    }}

                                    src={props.attributes.img_URL}
                                    alt={props.attributes.img_alt}
                                    width={props.attributes.image_size_dyna}
                              

                                    onMouseOver={imgHover}
                                    onMouseLeave={imgNormal}

                                />
                            </a>
                        </figure>
                    </div>


                    <div className="bb-ib-heading">
                        <RichText
                            style={{
                                fontStyle: props.attributes.title_font_style,
                                fontFamily: props.attributes.title_family,
                                fontWeight: props.attributes.title_weight,
                                fontSize: props.attributes.font_sizeib + props.attributes.pxfortile,
                                color: props.attributes.text_colr,
                                margin: "0px",
                                lineHeight: props.attributes.title_height + props.attributes.lineheightpxemfortitle,
                                letterSpacing: props.attributes.letter_spacing_title,
                                textTransform: props.attributes.text_transform,
                                textDecorationLine: props.attributes.text_decoration,
                                textShadow: props.attributes.text_shadow_horizental + 'px ' + props.attributes.text_shadow_vertical + 'px ' + props.attributes.title_shadow_blur + 'px ' + props.attributes.text_shadow_clors

                            }}
                            tagName={props.attributes.ibheadingtag}
                            value={props.attributes.ibheading}
                            onChange={(new_val) => {
                                props.setAttributes({ ibheading: new_val })
                            }}


                        />




                        <RichText className="bb-ib-content-description"
                            style={{

                                fontFamily: props.attributes.description_family,
                                fontWeight: props.attributes.description_weight,
                                fontSize: props.attributes.description_sizeib + props.attributes.description_empx,
                                color: props.attributes.para_clr,
                                lineHeight: props.attributes.description_height + "em",
                                fontStyle: props.attributes.description_font_style,
                                letterSpacing: props.attributes.letter_spacing_description,
                                textTransform: props.attributes.description_transform,
                                textDecorationLine: props.attributes.description_decoration,
                                textShadow: props.attributes.description_shadow_horizental + 'px ' + props.attributes.description_shadow_vertical + 'px ' + props.attributes.description_shadow_blur + 'px ' + props.attributes.description_shadow_clors




                            }}
                            tagName="p"
                            value={props.attributes.ibpara}
                            onChange={(new_val) => {
                                props.setAttributes({ ibpara: new_val })
                            }}


                        />

                    </div>
                </div>


                {/* dosra */}

                <div className="bb-ib-wrapper"
                    style={{
                        textAlign: props.attributes.txtalgn,
                        backgroundColor: props.attributes.bg_wrap,
                        paddingTop: props.attributes.pt_wrap,
                        paddingRight: props.attributes.pr_wrap,
                        paddingBottom: props.attributes.pb_wrap,
                        paddingLeft: props.attributes.pl_wrap,
                        display: props.attributes.display_left,
                        justifyContent: "center",
                        flexDirection: "row",
                        borderRadius: props.attributes.wrap_border_radius,
                        borderWidth: props.attributes.image_border,
                        borderStyle: props.attributes.border_style,
                        borderColor: props.attributes.bg_border,

                    }}>
                    <div className="bb-ib-icon"
                        style={{ alignSelf: props.attributes.alg }}
                    >

                        <figure >
                            <a href={props.attributes.icon_link} target={props.attributes.open_tab} rel={props.attributes.rel_nofollow}>

                                <img
                                    style={{
                                        // width: props.attributes.image_size+"%",
                                        // height: props.attributes.image_size,
                                        borderRadius: props.attributes.border_radius_img,
                                        marginLeft: props.attributes.headingml,
                                        marginRight: props.attributes.headingmr,
                                        marginTop: props.attributes.headingmt,
                                        marginBottom: props.attributes.headingmb,
                                        width: props.attributes.image_wrapper_size + "%",
                                        filter: `brightness(${props.attributes.css_brightness}%) contrast(${props.attributes.css_contrast}%) saturate(${props.attributes.css_saturation}%) blur(${props.attributes.css_blur}px) hue-rotate(${props.attributes.css_hue}deg)`,
                                        opacity: props.attributes.opacity_value,

                                    }}

                                    src={props.attributes.img_URL}
                                    alt={props.attributes.img_alt}
                                    width={props.attributes.image_size_dyna}
                                 
                                    onMouseOver={imgHover}
                                    onMouseLeave={imgNormal}

                                />
                            </a>
                        </figure>
                    </div>


                    <div className="bb-ib-heading">
                        <RichText
                            style={{
                                fontStyle: props.attributes.title_font_style,
                                fontFamily: props.attributes.title_family,
                                fontWeight: props.attributes.title_weight,
                                fontSize: props.attributes.font_sizeib + props.attributes.pxfortile,
                                color: props.attributes.text_colr,
                                margin: "0px",
                                lineHeight: props.attributes.title_height + props.attributes.lineheightpxemfortitle,
                                letterSpacing: props.attributes.letter_spacing_title,
                                textTransform: props.attributes.text_transform,
                                textDecorationLine: props.attributes.text_decoration,
                                textShadow: props.attributes.text_shadow_horizental + 'px ' + props.attributes.text_shadow_vertical + 'px ' + props.attributes.title_shadow_blur + 'px ' + props.attributes.text_shadow_clors

                            }}
                            tagName={props.attributes.ibheadingtag}
                            value={props.attributes.ibheading}
                            onChange={(new_val) => {
                                props.setAttributes({ ibheading: new_val })
                            }}


                        />




                        <RichText className="bb-ib-content-description"
                            style={{
                                fontFamily: props.attributes.description_family,
                                fontWeight: props.attributes.description_weight,
                                fontSize: props.attributes.description_sizeib + props.attributes.description_empx,
                                color: props.attributes.para_clr,
                                lineHeight: props.attributes.description_height + "em",
                                fontStyle: props.attributes.description_font_style,
                                letterSpacing: props.attributes.letter_spacing_description,
                                textTransform: props.attributes.description_transform,
                                textDecorationLine: props.attributes.description_decoration,
                                textShadow: props.attributes.description_shadow_horizental + 'px ' + props.attributes.description_shadow_vertical + 'px ' + props.attributes.description_shadow_blur + 'px ' + props.attributes.description_shadow_clors




                            }}
                            tagName="p"
                            value={props.attributes.ibpara}
                            onChange={(new_val) => {
                                props.setAttributes({ ibpara: new_val })
                            }}


                        />

                    </div>
                </div>



                {/* 3sra */}

                <div className="bb-ib-wrapper"
                    style={{
                        textAlign: props.attributes.txtalgn,
                        backgroundColor: props.attributes.bg_wrap,
                        paddingTop: props.attributes.pt_wrap,
                        paddingRight: props.attributes.pr_wrap,
                        paddingBottom: props.attributes.pb_wrap,
                        paddingLeft: props.attributes.pl_wrap,
                        display: props.attributes.display_right,
                        justifyContent: "center",
                        flexDirection: "row-reverse",
                        borderRadius: props.attributes.wrap_border_radius,
                        borderWidth: props.attributes.image_border,
                        borderStyle: props.attributes.border_style,
                        borderColor: props.attributes.bg_border,

                    }}>

                    <div className="bb-ib-icon"
                        style={{ alignSelf: props.attributes.alg }}
                    >

                        <figure >
                            <a href={props.attributes.icon_link} target={props.attributes.open_tab} rel={props.attributes.rel_nofollow}>

                                <img
                                    style={{
                                        // width: props.attributes.image_size+"%",
                                        // height: props.attributes.image_size,
                                        borderRadius: props.attributes.border_radius_img,
                                        marginLeft: props.attributes.headingml,
                                        marginRight: props.attributes.headingmr,
                                        marginTop: props.attributes.headingmt,
                                        marginBottom: props.attributes.headingmb,
                                        width: props.attributes.image_wrapper_size + "%",
                                        filter: `brightness(${props.attributes.css_brightness}%) contrast(${props.attributes.css_contrast}%) saturate(${props.attributes.css_saturation}%) blur(${props.attributes.css_blur}px) hue-rotate(${props.attributes.css_hue}deg)`,
                                        opacity: props.attributes.opacity_value,

                                    }}

                                    src={props.attributes.img_URL}
                                    alt={props.attributes.img_alt}
                                    width={props.attributes.image_size_dyna}
                             
                                    onMouseOver={imgHover}
                                    onMouseLeave={imgNormal}

                                />
                            </a>
                        </figure>
                    </div>


                    <div className="bb-ib-heading">
                        <RichText
                            style={{
                                fontStyle: props.attributes.title_font_style,
                                fontFamily: props.attributes.title_family,
                                fontWeight: props.attributes.title_weight,
                                fontSize: props.attributes.font_sizeib + props.attributes.pxfortile,
                                color: props.attributes.text_colr,
                                margin: "0px",
                                lineHeight: props.attributes.title_height + props.attributes.lineheightpxemfortitle,
                                letterSpacing: props.attributes.letter_spacing_title,
                                textTransform: props.attributes.text_transform,
                                textDecorationLine: props.attributes.text_decoration,
                                textShadow: props.attributes.text_shadow_horizental + 'px ' + props.attributes.text_shadow_vertical + 'px ' + props.attributes.title_shadow_blur + 'px ' + props.attributes.text_shadow_clors

                            }}
                            tagName={props.attributes.ibheadingtag}
                            value={props.attributes.ibheading}
                            onChange={(new_val) => {
                                props.setAttributes({ ibheading: new_val })
                            }}


                        />




                        <RichText className="bb-ib-content-description"
                            style={{
                                fontFamily: props.attributes.description_family,
                                fontWeight: props.attributes.description_weight,
                                fontSize: props.attributes.description_sizeib + props.attributes.description_empx,
                                color: props.attributes.para_clr,
                                lineHeight: props.attributes.description_height + "em",
                                fontStyle: props.attributes.description_font_style,
                                letterSpacing: props.attributes.letter_spacing_description,
                                textTransform: props.attributes.description_transform,
                                textDecorationLine: props.attributes.description_decoration,
                                textShadow: props.attributes.description_shadow_horizental + 'px ' + props.attributes.description_shadow_vertical + 'px ' + props.attributes.description_shadow_blur + 'px ' + props.attributes.description_shadow_clors


                            }}
                            tagName="p"
                            value={props.attributes.ibpara}
                            onChange={(new_val) => {
                                props.setAttributes({ ibpara: new_val })
                            }}


                        />

                    </div>
                </div>

            </div>

        )

    },

    save: (props) => {
        return (null)
    }
})